import React from 'react';
import { Card, Input } from 'reactstrap';
import { inject } from 'mobx-react';
var CollaboratorStretchSelect = inject('store')(function (props) {
    var stretches = props.stretches, selectedStretches = props.selectedStretches, onChange = props.onChange, children = props.children;
    return (React.createElement(Card, { className: "m-3 p-3" },
        React.createElement(Input, { onChange: onChange, name: "services", id: "services", type: "select", multiple: true, style: { height: stretches.length * 35 + 'px', overflow: 'hidden', borderWidth: 0 }, defaultValue: selectedStretches }, stretches.map(function (stretch) { return (React.createElement("option", { value: stretch.id, key: stretch.name, style: {
                textDecoration: stretch.disabled_at ? 'line-through' : 'inherit',
                paddingTop: '7px', paddingLeft: '20px', height: '25px'
            } }, stretch.name)); })),
        children));
});
export default CollaboratorStretchSelect;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/container/CollaboratorStretchSelect.tsx
// module id = 597
// module chunks = 0